//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.CurveFitData.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
let d=[[[0,"Associative",1,0],[1,"CurveFitData",0,"GeometricUtilities.CurveFitData",0],[0,"OffsetCurves",1,"Section",0],[1,"OffsetDistance",0,"Expression",0],[0,"OffsetViewDirection",1,"Direction",0],[0,"ReverseSide",1,0]],[[["inputCurve","point","reverseDirection"],"FlipOffsetCurveDirection",{},3,0]],[]];
SPLM.Features.Offset3DCurveBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.Offset3DCurveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;